import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useDispatch, useSelector } from 'react-redux';

import { PromoItemContainer } from '../PromoItemContainer';
import { newbuildingIdSelector, promosSelector, promosMoreButtonEnabledSelector } from '../../selectors/newbuilding';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';
import { FlatsError } from '../../components/FlatsError';
import { trackClickPromoBlock, trackPromoOffersShow } from '../../analytics/promos';
import { PromosMobile } from '../../components/PromosMobile';
import { Button } from '@cian/ui-kit/button';
import { MOBILE_PROMOS_LIMIT } from '../../constants/promos';
import { openPromo } from '../../slices';
import { TDispatch } from '../../types/redux';

export const MobilePromosSection: React.FC = () => {
  const dispatch: TDispatch = useDispatch();

  const promos = useSelector(promosSelector);
  const isMoreButtonEnabled = useSelector(promosMoreButtonEnabledSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);

  const [moreButtonShown, setMoreButtonShown] = React.useState(true);
  const [promosToShow, setPromosToShow] = React.useState<IPromoInfo[]>(promos.slice(0, MOBILE_PROMOS_LIMIT));

  const onShowMoreButtonClick = () => {
    setMoreButtonShown(false);
    setPromosToShow(promos);
  };

  const onPromoClick = React.useCallback(
    (promo: IPromoInfo) => {
      dispatch(openPromo(promo));
      trackClickPromoBlock(promo, newbuildingId);
    },
    [dispatch, newbuildingId],
  );

  const onBlockShow = React.useCallback(() => {
    trackPromoOffersShow(promos, newbuildingId);
  }, [promos, newbuildingId]);

  if (promos.length === 0) {
    return <FlatsError />;
  }

  return (
    <ActionAfterViewObserver callback={onBlockShow} triggerOnce>
      <PromosMobile>
        {promosToShow.map(promo => (
          <PromoItemContainer key={promo.uniquePromoId} promo={promo} onClick={onPromoClick} />
        ))}
        {isMoreButtonEnabled && moreButtonShown && (
          <Button theme="fill_secondary" size="M" onClick={onShowMoreButtonClick}>
            Показать все акции
          </Button>
        )}
      </PromosMobile>
    </ActionAfterViewObserver>
  );
};
